import React from 'react';

import * as InventoryFileConstants from 'inventory/InventoryFileConstants';
import TagValueViewer from 'metadata/TagValueViewer';

export default function HoistedTagValueCell(props) {
  return (
    <div className="metadata-field-row">
      <div className="metadata-field-col u-width-full">
        <TagValueViewer tag={props.tag} />
      </div>
    </div>
  );
}

HoistedTagValueCell.propTypes = {
  tag: InventoryFileConstants.HOISTED_TAG.isRequired,
};
